import { Component, OnInit } from '@angular/core';
import {MovimientosObraService} from '../../../services/movimientos-obra.service';
import {MovimientosObraProyeccionesService} from '../../../services/movimientos-obra-proyecciones.service';
import {HelpersService} from "../../../services/tools/helpers.service";
import { ValidatorService } from '../../../services/tools/validator.service';
declare var $;

@Component({
  selector: 'app-movimientos-modal',
  templateUrl: './movimientos-modal.component.html',
  styleUrls: ['./movimientos-modal.component.scss']
})
export class MovimientosModalComponent implements OnInit {

  modalTitle: string = "";
  searchProcess: any;
  searchText: string = "";
  filterData: any;
  obraFilterOptions: any;
  cuentasFilterOptions: any;
  conceptosFilterOptions: any;
  proveedoresFilterOptions: any;
  movimientosObra: any[];
  alterTable: any = 'starting';
  totales: any;
  printing: boolean = false;
  isProyecciones: boolean = false;

  constructor( private movimientosObraService: MovimientosObraService,
               private movimientosObraProyeccionesService: MovimientosObraProyeccionesService,
               private validatorService: ValidatorService,
               private helperService: HelpersService ) { }

  ngOnInit() {
    
  }
  close(){
    $('#movimientos-modal').modal('hide');
  }

  open(data,isProyecciones) {
    this.isProyecciones=isProyecciones;
    this.fill(data);
    $('#movimientos-modal').modal('show');
  }

  fill(data) {
    this.modalTitle = 'Movimientos de obra';
    this.searchText = data.searchText;
    this.filterData = data.filterData;
    this.obraFilterOptions = data.obraFilterOptions;
    this.cuentasFilterOptions = data.cuentasFilterOptions;
    this.conceptosFilterOptions = data.conceptosFilterOptions;
    this.proveedoresFilterOptions = data.proveedoresFilterOptions; 
    if(this.isProyecciones){
      this.searchProyecciones();
    }else{
      this.searchMovimientosObra();
    }
    
  }

  getObraFromOptions(id){
    for(let i =0 ; i< this.obraFilterOptions.length; i++){
      if(this.obraFilterOptions[i].idObras == id ){
        return this.obraFilterOptions[i].nombreObra;
      }
    }
  }
  getCuentaFromOptions(id){
    for(let i =0 ; i< this.cuentasFilterOptions.length; i++){
      if(this.cuentasFilterOptions[i].idCuentas == id ){
        return this.cuentasFilterOptions[i].bancoCuenta;
      }
    }
  }
  getConceptoFromOptions(id){
    for(let i =0 ; i< this.conceptosFilterOptions.length; i++){
      if(this.conceptosFilterOptions[i].idConceptos == id ){
        return this.conceptosFilterOptions[i].descripcion;
      }
    }
  }
  getProveedorFromOptions(id){
    for(let i =0 ; i< this.proveedoresFilterOptions.length; i++){
      if(this.proveedoresFilterOptions[i].text == 'Proveedores' ){
          for(let j =0 ; j< this.proveedoresFilterOptions[i].children.length; j++){
            if(this.proveedoresFilterOptions[i].children[j].idProveedores == id ){
              return this.proveedoresFilterOptions[i].children[j].nombre;
            }
          }
      }
    }
  }
  getInversionistaFromOptions(id){
    for(let i =0 ; i< this.proveedoresFilterOptions.length; i++){
      if(this.proveedoresFilterOptions[i].text == 'Inversionistas' ){
          for(let j =0 ; j< this.proveedoresFilterOptions[i].children.length; j++){
            if(this.proveedoresFilterOptions[i].children[j].idInversionistas == id ){
              return this.proveedoresFilterOptions[i].children[j].nombre;
            }
          }
      }
    }
  }
  searchMovimientosObra() {
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.getTotales();
      this.searchProcess = this.movimientosObraService.searchMovimientosObraWithFiltersNoPagination(this.searchText, this.filterData)
          .subscribe(response => {
            const content = response.json().content;
            this.movimientosObra = content.data;
            this.searchProcess = false;
            //this.startPaginate(content);
            this.alterTable = (this.movimientosObra.length > 0)? false: 'not_found';
          });
    } else {
      this.getMovimientosObra();
    }
  }
  searchProyecciones() {
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.getProyeccionesTotales();
      this.searchProcess = this.movimientosObraProyeccionesService.searchMovimientosObraWithFiltersNoPagination(this.searchText, this.filterData)
          .subscribe(response => {
            const content = response.json().content;
            this.movimientosObra = content.data;
            this.searchProcess = false;
            //this.startPaginate(content);
            this.alterTable = (this.movimientosObra.length > 0)? false: 'not_found';
          });
    } else {
      this.getProyecciones();
    }
  }

  getMovimientosObra() {
    console.log("Obteniendo movimientos");
    this.getTotales();
    this.searchProcess = this.movimientosObraService.getMovimientosObraWithFiltersNoPagination(this.filterData)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.reverse();
          //this.startPaginate(content);
          this.searchProcess = false;
          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_result';
          
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
            
          if (error == 400) {
            console.log('getMovimientosObra - error 400 ' , error);
          }
        });
  }
  getProyecciones() {
    this.getProyeccionesTotales();
    this.searchProcess = this.movimientosObraProyeccionesService.getMovimientosObraWithFiltersNoPagination(this.filterData)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content;
          //this.startPaginate(content);
          this.searchProcess = false;
          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_result';
          
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
            
          if (error == 400) {
            console.log('getMovimientosObra - error 400 ' , error);
          }
        });
  }

  getTotales() {
    this.movimientosObraService.getTotales(this.filterData)
      .subscribe((response) => {
        const respuesta = response.json();
        this.totales = respuesta.content;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
          
        if (error == 400) {
          console.log('getTotales - error 400 ' , error);
        }
      });
  }

  getProyeccionesTotales() {
    this.movimientosObraProyeccionesService.getTotales(this.filterData)
      .subscribe((response) => {
        const respuesta = response.json();
        this.totales = respuesta.content;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
          
        if (error == 400) {
          console.log('getTotales - error 400 ' , error);
        }
      });
  }

  isTraspasoIngreso(movimientoObra) {

    if (!movimientoObra.conceptos) {
      return false;
    }
    const isTraspasoIngreso = (movimientoObra.conceptos.traspaso == 1 && movimientoObra.tipoMovimiento == 2)? true: false;
    return isTraspasoIngreso;
  }

  isTipoMovimiento( tipoMovimiento, movimiento) {
    if ( !movimiento) {
      return false;
    }

    

    if (tipoMovimiento == 4 && movimiento.conceptos.traspaso == 1) {
      return true;
    }
    if (tipoMovimiento == movimiento.tipoMovimiento && movimiento.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }
  getTipoMovimiento( movimiento ) {
    if (movimiento.conceptos.traspaso == 1) {
      return 'TRASPASO';
    }
    
    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }
  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/movimientos-modal/movimientos-modal.component.ts